import type { FriendRecommendation } from '@/api/endpoints/friend-recommendation';
import { imageUrl } from '@/utils/image-url';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Image, Text, View } from 'react-native';

interface RecommendationsCardProps {
  recommendations: FriendRecommendation[];
}

export function RecommendationsCard({ recommendations }: RecommendationsCardProps) {
  if (recommendations.length === 0) return null;

  return (
    <View className="rounded-lg border border-border bg-surface p-3 mb-3" style={{ borderCurve: 'continuous' }}>
      <View className="flex-row items-center">
        <View className="flex-row mr-2">
          {recommendations.slice(0, 3).map((rec, index) => {
            const avatarUri = rec.sender_image
              ? imageUrl(rec.sender_image, 'thumbnail')
              : null;

            return (
              <View
                key={rec.id}
                className="rounded-full border-2 border-background overflow-hidden bg-surface-secondary"
                style={{
                  width: 28,
                  height: 28,
                  marginLeft: index > 0 ? -8 : 0,
                  zIndex: recommendations.length - index,
                }}
              >
                {avatarUri ? (
                  <Image
                    source={{ uri: avatarUri }}
                    className="w-full h-full"
                    accessibilityLabel={`${rec.sender_name || 'Friend'}'s photo`}
                  />
                ) : (
                  <View className="w-full h-full items-center justify-center">
                    <Ionicons name="person" size={14} className="text-muted-foreground" />
                  </View>
                )}
              </View>
            );
          })}
        </View>
        <Text className="flex-1 text-sm text-foreground" numberOfLines={2}>
          Recommended by{' '}
          <Text className="font-semibold">
            {recommendations
              .slice(0, 2)
              .map((r) => r.sender_name || 'a friend')
              .join(', ')}
            {recommendations.length > 2 && ` +${recommendations.length - 2} more`}
          </Text>
        </Text>
      </View>
    </View>
  );
}
